// extracted by mini-css-extract-plugin
module.exports = {"section":"BodyChangeSection_section__rr1iC","fullHeight":"BodyChangeSection_fullHeight__ZIEfF"};